


























import Heading from "../shared/Header.vue";
import { Vue, Component } from "@/shared/vuepack";
import { Permission } from "@/shared/types";
import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import ManageEmployers from "@/shared/components/ManageEmployers.vue";
import AddEmployerUserForm from "@/shared/components/AddEmployerUserForm.vue";
import { useUserStore } from "@/shared/store/user";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component ({
  components: {
    Heading,
    SettingsNavigation,
    ManageEmployers,
    AddEmployerUserForm
  }
})
export default class ManageUser extends Vue {
  userStore = useUserStore();
  rolePermissionsStore = useRolePermissionsStore();

  loaded = false;

  onLoaded () {
    this.loaded = true;
  }

  get hasManageUserWritePermission (): boolean {
    return this.rolePermissionsStore.userHasPermission(Permission.ManageUsersWrite);
  }
}
